import './Metrics.scss';
import toList from '../utils/ComponentUtil';
import Jobs from '../../images/worldwideJobs.png'
import Services from '../../images/services.png'
import Talents from '../../images/talent_metric.png'
import Employers from '../../images/employers.png'
import Projects from '../../images/projects.png'
import Internships from '../../images/internships.png'
import Carousel from '../utils/Carousel';

function Metrics({ }) {
    let metrics = [
        {
            name: 'Talents',
            img: Talents,
            amount: '100,000+'
        },
        {
            name: 'Employers',
            img: Employers,
            amount: '10,000+'
        },
        {
            name: 'Projects',
            img: Projects,
            amount: '15,000+'
        },
        {
            name: 'Internships',
            img: Internships,
            amount: '1,000+'
        },
        {
            name: 'Jobs World Wide',
            img: Jobs,
            amount: '50,000+'
        }
    ]
    return (
        <div className="site-metrics">
            {toList(metrics, undefined, (item, i) =>
                <div className="metric" key={i}>
                    <img className="icon" src={item?.img} alt="icon" />
                    <div className="details" >
                        <div className="amount" >{item?.amount}</div>
                        <div className="unit" >{item?.name}</div>
                    </div>
                </div>)}
        </div>
    );
}

export default Metrics;